<template>
    <el-card shadow="hover">
        <label slot="header">JColourTag颜色标签</label>
        <el-divider content-position="left">select color="#90EE90" desc="描述文字" value="8"</el-divider>
        <j-colour-tag color="#4169E1" desc="标签" :value="0" />
        <j-colour-tag color="#00FA9A" desc="描述文字" value="突出文字" />
        <j-colour-tag color="#FFA500" desc="超长文字样式展示" value="999999999" />
        <j-colour-tag select color="#90EE90" desc="选中样式" :value="8" />
    </el-card>
</template>

<script>
    import JColourTag from "./JColourTag";
    export default {
        name: "JColourTagDemo",
        components: {
            JColourTag
        }
    }
</script>
